module.exports = __webpack_public_path__ + "static/media/47_B.908ae82a.png";